import { episodeTimes } from '../../util/episodes';

/**
 * Denormalise transactions to events that
 * can be used in react/@fullcalendar.
 *
 * @param {array} transactions
 *
 * @returns {array} events
 */
export const transactionsToEvents = transactions => {
  return transactions.map(transaction => {
    const { listing, booking } = transaction;
    const { metadata } = transaction.attributes;
    // A rescheduled episode keeps its booking, made for the old time; the
    // Live Room says where the episode is now.
    const current = episodeTimes(listing, metadata?.timeslot?.id);

    return {
      id: transaction.id.uuid, // has to be ID string
      listingId: listing.id,
      title: metadata.timeslot.name,
      start: current ? current.start : booking.attributes.start,
      end: current ? current.end : booking.attributes.end,
    };
  });
};

/**
 * Episodes the member reserved without a booking (from the episode card in
 * Conversations), in the same shape. `reservation` tells the event pop-up
 * there is no booking behind it.
 *
 * @param {array} episodes from /api/episodes/mine
 *
 * @returns {array} events
 */
export const reservationsToEvents = episodes =>
  episodes
    .filter(e => e.start && e.end)
    .map(e => ({
      id: `reservation-${e.episodeId}`,
      listingId: e.listingId,
      title: e.title,
      start: new Date(e.start),
      end: new Date(e.end),
      reservation: true,
      timeslot: { id: e.episodeId, name: e.title, meeting: e.meeting },
    }));

/**
 * Sort events by their start dates to get the
 * upcoming events.
 *
 * @param {array} events
 *
 * @returns {array} sorted events
 */
export const sortEventsByDate = events =>
  events.sort(function(a, b) {
    var c = new Date(a.start);
    var d = new Date(b.start);
    return c - d;
  });

/**
 * Get's the upcoming bookings that's ahead of the
 * current date.
 *
 * @param {array} events
 *
 * @returns {array} upcoming events
 */
export const upcomingEventsByDate = events => events.filter(e => new Date(e.start) >= new Date());
